import * as React from 'react';

import AreaHeader from '@app/components/UI/Area-blocks/AreaHeader/AreaHeader';

const AreaMemorialKeepsakes = (props) => {
	const {area} = props;

	return (
		<>
			<div className="area">
				<AreaHeader area={area}/>

				<article className="middle-text">
					<h4 className="middle-text__title">Memorialize your pet</h4>
					<div className="middle-text__text">
						<p>
							When your pet is no longer physically present, keeping their memory alive through a memento
							or keepsake can both honor them and help ease the grieving process. Whether it’s a painting
							of your pet or a necklace made from their pawprint, an object that you can hold in your hand
							creates a sense of everlasting connection.
						</p>
						<p>
							Our Pet Memorial Keepsakes site was created for those who seek comfort in mementos after
							saying goodbye to a pet. The site offers a range of unique memorial items from carefully
							selected companies. We hope you find an item that perfectly symbolizes the forever bond
							between you and your beloved friend.
						</p>
					</div>
				</article>
				<div className="middle-text">
					<a href="https://info.lapoflove.com/keepsakes" target="_blank" className="btn btn-md btn-primary btn-more">
						View Keepsakes
					</a>
				</div>
			</div>
		</>
	);
};

export default AreaMemorialKeepsakes;